import React from 'react';
import { HVAConversationProvider } from './HVADebtCollectionContext';
import HVADynamicConversationModalContent from './HVADebtCollectionModalContent';
import { HVADynamicConversationModalProps } from './HVADebtCollectionData';

const HVADebtCollectionModal: React.FC<
  HVADynamicConversationModalProps
> = props => {
  return (
    <HVAConversationProvider>
      <HVADynamicConversationModalContent {...props} />
    </HVAConversationProvider>
  );
};

export default HVADebtCollectionModal;
